module.exports = __webpack_public_path__ + "img/mc_top.a2b59886.jpg";